<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
  <!--<el-button type="primary" size="mini" @click="openRaceIframe(0)">경주등록</el-button>-->
  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
      
       empty-text="데이타가 없습니다">
 
      <el-table-column 
        label="구분" prop="cc" align="center"> 
        <template slot-scope="scope">
        {{nara[scope.row.race_jang]}}
      </template>    
      </el-table-column>

       <el-table-column 
        label="장소" prop="cc" align="center"> 
        <template slot-scope="scope">
        {{jsarr[scope.row.race_jang]}}
      </template>    
      </el-table-column>
      <el-table-column 
        label="시작" prop="min_time" align="center">     
      </el-table-column>
      <el-table-column 
        label="마감" prop="max_time" align="center">     
      </el-table-column>
      <el-table-column 
        label="회차" prop="race_jang" align="center"> 
         <template slot-scope="scope">
        <el-button type="text" @click="openRacelist(scope)">{{scope.row.cc}}</el-button>
      </template>       
      </el-table-column>
     

    
      </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					 
				  </div>
				</el-footer>
        <el-dialog
            :visible.sync="dVisible" :width="raceWith" :close-on-click-modal ="false">
            <div>

              <template v-for=" (item,index) in jangSo ">
              <div v-if="item.length>0" class="jangso">
              {{jangsos[index]}}:  <el-button type="text" v-for="(item2,index2) in item" :key="index2" @click="jangsoData(item2)" :class="item2.race_jang === select_race_idx ? 'text-danger':'text-primary'">{{jsarr[item2.race_jang]}}</el-button>
              </div>
            </template>

            

            </div>
            <el-table
                :data="racelistData" v-loading="loading1"
                style="width: 100%">

                


                <el-table-column label="경주" prop="race_num" align="center" width="80">
                   <template slot-scope="scope">
                        <el-input type="number" v-model="scope.row.race_num" size="mini"></el-input>
                   </template>
                </el-table-column>
                 <el-table-column label="날짜"  prop="race_date" width="120" align="center">
                   <template slot-scope="scope">
                        <el-input type="text" v-model="scope.row.race_date" size="mini"></el-input>
                   </template>   
                </el-table-column>
                <el-table-column label="인원" prop="race_su" align="center" width="80">
                   <template slot-scope="scope">
                        <el-input type="number" v-model="scope.row.race_su" size="mini" ></el-input>
                   </template>           
                </el-table-column>
                <el-table-column  label="시간" prop="race_time"  align="center" width="70">
                  <template slot-scope="scope">
                        <el-input type="text" v-model="scope.row.race_time" size="mini" ></el-input>
                   </template>
                </el-table-column>
                <el-table-column label="거리" prop="race_movie"  align="center" width="80" >
                  <template slot-scope="scope">
                   
                        <el-input type="number" v-model="scope.row.race_movie" size="mini" ></el-input>
                        
                     
                   </template>
                </el-table-column>
                <el-table-column label="상태" prop="status"  align="center" width="100">
                   <template slot-scope="scope">
                   
                      
                         <el-select v-model="scope.row.status" placeholder="" size="mini">
                           <el-option
                                  v-for="item in statusOptions"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                     
                   </template>
                </el-table-column>

              
                   <el-table-column  label="편집" align="center">
                   <template  slot-scope="scope">
                  
                     <el-button-group>

                          <el-button v-if="scope.row.race_idx!=''" type="primary" icon="el-icon-edit" size="mini" @click="editRace(scope)"></el-button>
                          <el-button v-if="scope.row.race_idx!=''" type="danger" icon="el-icon-delete" size="mini" @click="deleteRace(scope)"></el-button>

                          <el-button v-if="scope.row.race_idx==''" type="primary" icon="el-icon-check" size="mini" @click="insertRace(scope)"></el-button>
                         
                     </el-button-group>
                  
                    </template>
                  </el-table-column>
             

                

                 
              
              
              </el-table>
  
            <span slot="footer" class="dialog-footer">
               <el-button @click="addClick" type="primary">회차추가</el-button>
               <el-button @click="dVisible = false">닫기</el-button>
        
            </span>
          </el-dialog>	
        
				
</div>
 </template>

 <script>
 import raceDialog from '../../components/common/race-dialog.vue';
 
    export default {
     components: {
     
         raceDialog
    },
    	data(){
    		return{
         
         
       raceWith:'660px',
          dVisible:false,
          racelistData:[],
          jangsos:["한국경마","일본경마","일본경정","일본경륜","중앙경마"],
          select_race_idx:'',
          jangSo:[],
          nara:new Array("","한국경마", "한국경마", "한국경마", "한국경륜", "한국경륜", "한국경정", "한국경륜", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경마", "일본경륜", "일본경륜", "일본경륜", "일본경륜", "일본경륜", "일본경륜", "일본경륜", "일본경륜", "일본경륜", "일본경륜", "일본경륜", "일본경륜", "일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜","일본경륜", "일본경정", "일본경정", "일본경정", "일본경정", "일본경정", "일본경정", "일본경정", "일본경정", "일본경정", "일본경정", "일본경정","","","","","","","","","","중앙경마","중앙경마","중앙경마","중앙경마","중앙경마","중앙경마","중앙경마","중앙경마","중앙경마"),
          jsarr:new Array("", "부산", "과천", "제주", "광명", "창원", "미사리", "부산(경륜)", "나고야", "미즈사와", "사가", "삿포로", "소노다", "아라오", "오비히로", "우라와", "카나자와", "코치", "후쿠야마", "후나바시", "카와사키", "아사히카와", "카사마츠", "오오이", "모리오카", "몬베츠", "히메지", "이와키", "벳푸", "가와사키", "마에바시", "오미야", "무코마치", "다카마쓰", "게이오카쿠", "이토", "도야마","키시와다", "마츠야마", "오구라","히라츠카","사세보","마츠도","오가키","나고야","마쓰사카","구루메","도요하시","와카야마","히로시마","오다와라","시즈오카","기후","나라","다치카와","욧카이치","세이부엔","후쿠이","우츠노미야","다케오", "에도가와", "스미노에", "헤이와지마", "하마나코", "아마가사키", "나루토", "다마가와", "마루가메", "토다", "기류","가마고오리","","","","","","","","","","한신", "나카야마", "쥬쿄","오구라","도쿄","니가타","삿포로","후쿠시마","하코다테"),
          domain:window.sessionStorage.getItem('domain'),
    		disabled:false,
        btn_select:'',
        statusOptions:[
        {
              label:'정상',
              value:'1'
            },
             {
              label:'취소',
              value:'0'
            },
        ],
        status:'',
          
          valuenum:'1',

		    		 loading: false,
            loading1: false,
		    		 tableData: [],
			   

    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
   
    	methods:{
        openRaceIframe(id){
             this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: raceDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['700px', '800px'],
         
        });
        },
         //添加
         addClick() {

          this.insert=1;


            // console.log(this.racelistData[0].race_date);
            let date=''
            if(this.racelistData.length>0)
            {
               date=this.racelistData[0].race_date
            }
              var list = {
                race_num: '',
                race_idx: '',
                race_date: date,
                race_su: '',
                race_time: '',
                race_movie: '',
                status: "1",

               
              };
              this.racelistData.push(list);
            },


         jangsoData(item){
           //console.log(item.race_jang)
            this.loading1 = true
            this.select_race_idx=item.race_jang
           // console.log('this.select_race_idx',this.select_race_idx);
            let token=window.sessionStorage.getItem('user');
            this.$axios({
                      method:'get',
                      url:this.domain+'/admin/race_list_by_jangso?id='+item.race_jang,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                      this.racelistData = response.data.data
                      this.loading1 = false
                     
                  
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
           
         },
       
         //编辑
         editRace(e){
            this.loading = true
            let token=window.sessionStorage.getItem('user');
            this.$axios({
                      method:'post',
                      url:this.domain+'/admin/race_up',
                      data:{
                        race_idx:e.row.race_idx,
                        race_su:e.row.race_su,
                        race_date:e.row.race_date,
                        race_num:e.row.race_num,
                        race_su:e.row.race_su,
                        race_time:e.row.race_time,
                        race_movie:e.row.race_movie,
                        status:e.row.status,

                      },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    if(response.data.code ==200){
                        this.$message({
                                message:response.data.msg,
                                type: 'success'
                                  });
                    }else{
                      this.$message.error(response.data.msg);
                    }
                        this.loading = false

                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
           
         },
         //INSERT
         insertRace(e){
            this.loading1 = true
            let token=window.sessionStorage.getItem('user');
            this.$axios({
                      method:'post',
                      url:this.domain+'/admin/race_insert',
                      data:{
                       
                        race_su:e.row.race_su,
                        race_date:e.row.race_date,
                        race_num:e.row.race_num,
                        race_jang:this.select_race_idx,
                        race_time:e.row.race_time,
                        race_movie:e.row.race_movie,
                        status:e.row.status,

                      },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    if(response.data.code ==200){
                        this.$message({
                                message:response.data.msg,
                                type: 'success'
                                  });
                           this.openRacelistview();

                    }else{
                      this.$message.error(response.data.msg);
                    }
                        this.loading1 = false

                   
                  }).catch((error) =>{
                     // console.log(error)       //请求失败返回的数据
                     this.loading1 = false
                     this.$message.error(error);
                  })
           
         },
         //删除
         deleteRace(e){
          console.log('index==',e.$index)
            this.$confirm('삭제하시겠습니까?', '알림', {
              confirmButtonText: '삭제',
              cancelButtonText: '취소',
              type: 'warning'
            }).then(() => {
              let token=window.sessionStorage.getItem('user');
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/race_del',
                      data:{
                        race_idx:e.row.race_idx,
                    

                      },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }
                    // this.racelistData.splice(e.$index,1)
                    this.openRacelistview()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: '취소됨'
          });          
        });
         },

         openRacelist(e){
            this.loading1 = true
            this.dVisible = true
            let token=window.sessionStorage.getItem('user');
            this.select_race_idx=e.row.race_jang;
           

            this.$axios({
                      method:'get',
                      url:this.domain+'/admin/race_list_by_jangso?id='+e.row.race_jang,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                      //console.log('racelistData',response.data)
                      this.racelistData = response.data.data
                      this.jangSo = response.data.jangso

                      this.loading1 = false
                  
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
         
         },

         openRacelistview(){
            this.loading = true

            let token=window.sessionStorage.getItem('user');
            this.$axios({
                      method:'get',
                      url:this.domain+'/admin/race_list_by_jangso?id='+this.select_race_idx,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                     
                      this.racelistData = response.data.data
                      this.jangSo = response.data.jangso
                      this.loading = false
                  
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
         
         },
    			
    		

    		getList(){

    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');

          
    				//console.log(token);
    			 let urls=this.domain+'/admin/race_list';

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('tableData=',response.data.data)
                     let data = response.data.data
                     this.tableData =data
                    
                     
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
              
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    	
    
    		
    	}
  }
</script>

 <style scoped>
/deep/.el-table .el-table__cell{
  padding:5px 0
}
/deep/.h20 .el-input__inner{
  height:20px;
  line-height:20px;
}
/deep/ .dialog__body {
  padding:10px;
}
/deep/ .el-dialog__body{
  padding:0 10px;
}
/deep/ .jangso .el-button{
  padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/racelist/list.vue